import useApp from "./useApp";
import { useCoordinates } from "./useCoordinates";
import useData from "./useData";
import { useMinifiedMenu } from "./useMinifiedMenu";
import { usePins } from "./usePins";
import useScreen from "./useScreen";
import useSignalR from "./useSignalR";
import { useUnityActions } from "./unityActions";
import useUnity from "./UseUnity";
import { useDxfWidgets } from "pages/sld/hooks/useDxfWidgets";
import { useAiChat } from "./AiChatContext";
import { useAlarmNotifications } from "./useAlarmNotifications";

const allHooks = {
  useApp,
  useData,
  useScreen,
  useSignalR,
  useCoordinates,
  useUnity,
  usePins,
  useMinifiedMenu,
  useUnityActions,
  useDxfWidgets,
  useThemeColorPicker: null,
  useAiChat,
  useAlarmNotifications
};

export default allHooks;